'use strict';
  
angular.module('sellersService')
.factory('PropertyService', ['appInfo', '$log', '$rootScope', '$http', '$q', 'CacheFactory',
    function (appInfo, $log, $rootScope, $http, $q, CacheFactory) {
        var service = {}
            , api_key = appInfo.key
            , endpoint = appInfo.endpoint
            ;

        service.getProperty = function(listingRef) {
            var dfd = $q.defer();
            $http({
                    url: endpoint+'listing/listing.json/'+listingRef, 
                    method: "GET",
                    params: {api_key: api_key},
                    transformResponse: function (data, headers) {                     
                      return JSON.parse(data);
                    }
                 }).success(function(data, status, headers, config) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;
        };

        service.getListingImage = function(listingRef) {
            var dfd = $q.defer();

            service.getProperty(listingRef).then(function(rs){
                var image = (rs[0].marketing[0].images.img.length > 0)?
                                    rs[0].marketing[0].images.img[0] : 
                                    '../images/bg-house-tinted.jpg';

                dfd.resolve(image);
            })

            return dfd.promise;
        };

        return service;

}]);